import React, { useState, useContext, useEffect, useRef, Suspense } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import {
  deleteSprintTask, deleteTask, getProjectTaskList, sprintUpdateStatus,
  getProjectModule, getProjectSubModule, getProjectSegment, getProjectList,
  moveTOSprintTask
}
  from "./Service/TaskService";
import { TostMsg } from "../../../App";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { getEmployeeList } from "../EmployeeList/Service/employeeService.js";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { ProjectModalContext } from "./Service/ProjectModalContext";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import AddTask from "./Add-Task.jsx";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader.jsx";
import { Paginator } from "primereact/paginator";
import { getRawPermissionsArray } from "../../../Routes/AuthGard/usePermissions.js";


/* ── status pill class (reuse pss- pill system) ── */
const pillClass = (status) => {
  const map = {
    Active: "pill pill--active",
    Open: "pill pill--open",
    "In Progress": "pill pill--inprog",
    Review: "pill pill--review",
    Done: "pill pill--done",
    Closed: "pill pill--done",
    Archived: "pill pill--archived",
  };
  return map[status] || "pill pill--default";
};

function SprintSection() {
  const location = useLocation();
  const history = useHistory();
  // const { view } = location.state || {};
  const { view, sprint: stateSelectedSprint } = location.state || {};
  console.log(stateSelectedSprint, "sprint")

  const { selectedProject: contextProject, updateSelectedProject, refreshSelectedProject } = useContext(ProjectModalContext);
  // const activeSprint = contextProject?.ProjectSprints?.ActiveSprint || null;
  // const planningSprints = contextProject?.ProjectSprints?.PlanningSprint || [];
  // const planningSprint = planningSprints[0] || null;

  const PLANNING_STATUS_ID = 1;
  const ACTIVE_STATUS_ID = 2;
  const PAUSED_STATUS_ID = 3;

  const rawActiveSprint = contextProject?.ProjectSprints?.ActiveSprint || null;
  const rawPlanningSprints = contextProject?.ProjectSprints?.PlanningSprint || [];

  // Collect ALL sprints from both fields so we can classify by real StatusId
  const allSprintsPool = [
    ...(rawActiveSprint ? [rawActiveSprint] : []),
    ...rawPlanningSprints,
  ];

  // True active = currently running or paused (StatusId 2 or 3)
  const trulyActiveSprint = allSprintsPool.find(
    s => s.SprintStatusId === ACTIVE_STATUS_ID || s.SprintStatusId === PAUSED_STATUS_ID
  ) || null;

  // True planning = StatusId 1
  const trulyPlanningSprintsAll = allSprintsPool.filter(
    s => s.SprintStatusId === PLANNING_STATUS_ID
  );

  // For view="active" use trulyActiveSprint; for view="planning" use the clicked one
  const activeSprint = trulyActiveSprint;

  const planningSprints = trulyPlanningSprintsAll;
  // const planningSprint = stateSelectedSprint
  //   ? (trulyPlanningSprintsAll.find(s => s.Id === stateSelectedSprint.Id) || stateSelectedSprint)
  //   : trulyPlanningSprintsAll[0] || null;
  const planningSprint = stateSelectedSprint
    ? (trulyPlanningSprintsAll.find(s => s.Id === stateSelectedSprint.Id) || stateSelectedSprint)
    : trulyPlanningSprintsAll[0] || null;

  // const currentProjectId =
  //   activeSprint?.ProjectId || planningSprint?.ProjectId || contextProject?.Id || null;

  // ID of the project currently shown on this page (from context)
  const currentProjectId =
    activeSprint?.ProjectId || planningSprint?.ProjectId || contextProject?.Id || null;

  const toster = useContext(TostMsg);

  const [isDeleteActiveModal, setDeleteActiveModal] = useState(false);
  const [isDeletePlanningModal, setDeletePlanningModal] = useState(false);
  const [isPauseModal, setPauseModal] = useState(false);
  const [isStopModal, setStopModal] = useState(false);
  const [isResumeModal, setResumeModal] = useState(false);
  const [sprintStatus, setSprintStatus] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [filteredTasks, setFilteredTasks] = useState([]);
  // const [currentSprintStatusId, setCurrentSprintStatusId] = useState(activeSprint?.SprintStatusId || null);
  const [currentSprintStatusId, setCurrentSprintStatusId] = useState(trulyActiveSprint?.SprintStatusId || null);
   const [selectedTask, setSelectedTask] = useState(null);

  // ═══════ FILTER STATES ═══════
  const [filterOpen, setFilterOpen] = useState(false);
  const [inputText, setInputText] = useState("");
  const [searchText, setSearchText] = useState("");
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedAssingToName, setSelectedAssingToName] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [selectedPriority, setSelectedPriority] = useState([]);
  const [selectedSeverity, setSelectedSeverity] = useState([]);
  // selectedProject here is the FILTER's project id (Dropdown value), pre-filled from context
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedModule, setSelectedModule] = useState([]);
  const [selectedSubModule, setSelectedSubModule] = useState([]);
  const [selectedSegment, setSelectedSegment] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("ASC");

  // Master data for filters
  const [taskStatusType, setTaskStatusType] = useState([]);
  const [taskType, setTaskType] = useState([]);
  const [taskPriorityType, setTaskPriorityType] = useState([]);
  const [taskSeverityType, setTaskSeverityType] = useState([]);
  const [employeDetails, setEmployeDetails] = useState([]);
  const [allProject, setAllProject] = useState([]);
  const [taskModuleType, setTaskModuleType] = useState([]);
  const [taskSubModuleType, setTaskSubModuleType] = useState([]);
  const [taskSegmentType, setTaskSegmentType] = useState([]);

  const debounceTimerRef = useRef(null);
  const selectedProjectRef = useRef(selectedProject);

  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const getValue = (val) => (val ? val : "N/A");


  // ── TASK ACTION STATES ──
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [showBulkBar, setShowBulkBar] = useState(false);
  const [isDeletedModal, setDeleteModal] = useState(false);
  const [deletedTaskId, setDeletedTaskId] = useState(0);
  const [isModalOpen, setAddModalOpen] = useState(false);
  const [editTaskDetails, setEditTaskDetails] = useState({});
  const [parentId, setParentId] = useState(0);
  const [subTaskProjectId, setProjectId] = useState(0);
  const [taskCopy, setTaskCopy] = useState(false);
  const [isSprintModal, setIsSprintModal] = useState(false);
  const [isPauseSprintModal, setIsPauseSprintModal] = useState(false);
  const [moveSprint, setMoveSprint] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sprintDropdownTaskId, setSprintDropdownTaskId] = useState(null);
  const [selectedProjectData, setSelectedProjectData] = useState(null);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const rowsRef = useRef(rows);
  const [createProject, setCreateProject] = useState(false);
  let userPermissions = getRawPermissionsArray();


  const permissionList = () => {
    if (userPermissions) {
      userPermissions?.map((UserPermission) => {
        if (UserPermission?.PermissionName === "Project.Create") setCreateProject(true);
      });
    }
  };

  const onPageChange = (e) => {
    setFirst(e.first);
    setRows(e.rows);
    rowsRef.current = e.rows;
    const newPage = Math.floor(e.first / e.rows) + 1;
    setPageNumber(newPage);
    getProjectTask(newPage, e.rows);
  };
  useEffect(() => {
    rowsRef.current = rows;
  }, [rows]);

  useEffect(() => {
    const handleOutsideClick = () => setSprintDropdownTaskId(null);
    if (sprintDropdownTaskId !== null) {
      document.addEventListener("click", handleOutsideClick);
    }
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [sprintDropdownTaskId]);

  useEffect(() => {
    permissionList();
    getSprintStatus();
    getMasterData();
  }, []);

  // ─── Pre-select project from context (defaults the filter dropdown) ───
  useEffect(() => {
    if (currentProjectId) {
      setSelectedProject(currentProjectId);
      selectedProjectRef.current = currentProjectId;
      getMasterTaskModulesCategory(currentProjectId);
      getMasterTaskSegmentCategory(currentProjectId);
    }
  }, [currentProjectId]);

  useEffect(() => {
    const projectId = activeSprint?.ProjectId || planningSprint?.ProjectId;
    if (projectId) {
      setFirst(0);
      setPageNumber(1);
      getProjectTask(1, rowsRef.current);
    }
  }, [
    view,
    activeSprint?.ProjectId,
    planningSprint?.ProjectId,
    planningSprint?.Id,          // ← ADD THIS — re-fetch when the selected planning sprint changes
    selectedStatus, selectedAssingToName, selectedType,
    selectedPriority, selectedSeverity, selectedModule,
    selectedSubModule, selectedSegment, searchText, sortBy, sortOrder
  ]);

  useEffect(() => {
    setCurrentSprintStatusId(activeSprint?.SprintStatusId || null);
  }, [activeSprint?.SprintStatusId, activeSprint?.Id]);

  useEffect(() => {
    selectedProjectRef.current = selectedProject;
  }, [selectedProject]);

  const formatDate = (d) => {
    if (!d) return "—";
    return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  };

  const calcProgress = (completed, total) => (!total ? 0 : Math.round((completed / total) * 100));

  // ═══════ MASTER DATA FUNCTIONS ═══════
  async function getMasterData() {
    setIsLoading(true)
    try {
      const [statusData, typeData, priorityData, severityData, employeeData, projectData] = await Promise.all([
        GetMasterTypeData({ organisationId: userDetails?.OrgId, masterType: "TaskStatus" }),
        GetMasterTypeData({ organisationId: userDetails?.OrgId, masterType: "TaskType" }),
        GetMasterTypeData({ organisationId: userDetails?.OrgId, masterType: "TaskPriority" }),
        GetMasterTypeData({ organisationId: userDetails?.OrgId, masterType: "TaskSeverity" }),
        getEmployeeList({
          OrganisationId: userDetails?.OrgId,
          LoggedInEmployeeId: userDetails?.EmpId,
          pageNumber: 1,
          pageSize: 10000,
        }),
        getProjectList({
          Id: 0,
          StartDate: "",
          EndDate: "",
          ProjectStatusId: "",
          PageNumber: 1,
          PageSize: 1000,
          Search: "",
          ProjectTypeId: "",
          ClientId: "",
          SortBy: "",
          SortOrder: "",
        }),
      ]);
      setIsLoading(false)
      setTaskStatusType(statusData?.Data || []);
      setTaskType(typeData?.Data || []);
      setTaskPriorityType(priorityData?.Data || []);
      setTaskSeverityType(severityData?.Data || []);
      setEmployeDetails(employeeData?.Data || []);
      setAllProject(projectData?.Data?.ProjectList || []);
    } catch (e) {
      setIsLoading(false)
      toster.current.error(ERROR_LIST?.MasterDataType || "Failed to load filter data");
    }
  }

  async function getMasterTaskModulesCategory(projectId = 0) {
    if (!projectId) return;
    setIsLoading(true)
    try {
      const data = await getProjectModule({ ProjectId: Number(projectId) });
      setTaskModuleType(data?.Data || []);
      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)
      toster.current.error(e?.response?.data?.Message || "Failed to load modules");
    }
  }

  async function getMasterTaskSubModuleCategory(projectId = 0, moduleId = 0) {
    if (!projectId || !moduleId) return;
    setIsLoading(true)
    try {
      const data = await getProjectSubModule({ ProjectId: Number(projectId), ModuleId: Number(moduleId) });
      setTaskSubModuleType(data?.Data || []);
      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)
      toster.current.error(e?.response?.data?.Message || "Failed to load sub-modules");
    }
  }

  async function getMasterTaskSegmentCategory(projectId = 0) {
    if (!projectId) return;
    setIsLoading(true)
    try {
      const data = await getProjectSegment({ ProjectId: Number(projectId) });
      setTaskSegmentType(data?.Data || []);
      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)
      toster.current.error(e?.response?.data?.Message || "Failed to load segments");
    }
  }

  const hasActiveFilters =
    searchText ||
    selectedStatus?.length > 0 ||
    selectedPriority?.length > 0 ||
    selectedSeverity?.length > 0 ||
    selectedModule?.length > 0 ||
    selectedSubModule?.length > 0 ||
    selectedSegment?.length > 0 ||
    selectedAssingToName?.length > 0 ||
    selectedType?.length > 0 ||
    sortBy;

  const toggleSection = (key) => {
    if (key === "filter") setFilterOpen(!filterOpen);
  };

  const toggleSortOrder = () =>
    setSortOrder((prev) => (prev === "ASC" ? "DESC" : "ASC"));

  const clearFilters = () => {
    setInputText("");
    setSearchText("");
    setSelectedStatus([]);
    setSelectedPriority([]);
    setSelectedSeverity([]);
    setSelectedModule([]);
    setSelectedSubModule([]);
    setSelectedSegment([]);
    setSelectedAssingToName([]);
    setSelectedType([]);
    setSortBy("");
    setSortOrder("ASC");

    // Reset project filter back to the page's default project (not null)
    setSelectedProject(currentProjectId);
    selectedProjectRef.current = currentProjectId;
    if (currentProjectId) {
      getMasterTaskModulesCategory(currentProjectId);
      getMasterTaskSegmentCategory(currentProjectId);
    } else {
      setTaskModuleType([]);
      setTaskSubModuleType([]);
      setTaskSegmentType([]);
    }
  };

  const SORT_OPTIONS = [
    { label: "Modified On (Default)", value: "" },
    { label: "Assigned To", value: "AssignedToName" },
    { label: "Priority", value: "PriorityId" },
    { label: "Severity", value: "SeverityId" },
    { label: "Type", value: "TaskTypeId" },
    { label: "Module", value: "ModuleName" },
    { label: "Sub Module", value: "SubModuleName" },
    { label: "Status", value: "StatusId" },
    { label: "Created On", value: "CreatedOn" },
  ];

  async function getSprintStatus() {
    try {
      const data = await GetMasterTypeData({ organisationId: userDetails?.OrgId, masterType: "SprintStatus" });
      setSprintStatus(data?.Data);
    } catch { toster.current.error(ERROR_LIST?.MasterDataType); }
  }

  const sprintStatusMap = sprintStatus?.reduce((map, s) => { if (s?.Code) map[s.Code] = s; return map; }, {});
  const getStatusId = (code) => sprintStatusMap?.[code]?.Id ?? null;
  const pausedId = getStatusId("Paused");
  const activeId = getStatusId("Active");
  const isSprintPaused = pausedId != null ? currentSprintStatusId === pausedId : currentSprintStatusId === 3;
  const isSprintActive = activeId != null ? currentSprintStatusId === activeId : currentSprintStatusId === 2;


  // 2. handleSprintStatusUpdate mein add karo
  // AFTER:
  const handleSprintStatusUpdate = async (newStatusCode, modalCloser, successMsg) => {
    const statusId = getStatusId(newStatusCode);
    if (!statusId) {
      toster.current.error(`Unable to update sprint status.`);
      modalCloser(false);
      return;
    }
    setIsLoading(true)
    // Determine which sprint is being updated based on current view
    const sprintToUpdate = view === "planning" ? planningSprint : activeSprint;

    try {
      const response = await sprintUpdateStatus({
        ID: sprintToUpdate?.Id,
        ProjectId: sprintToUpdate?.ProjectId,
        NewStatusId: statusId,
        Remarks: ""
      });
      setIsLoading(false)
      toster.current.success(response?.Data?.Message || successMsg);
      setCurrentSprintStatusId(statusId);

      // When a planning sprint is activated → move it to ActiveSprint, remove from PlanningSprint
      if (newStatusCode === "Active" && view === "planning") {
        const updatedPlanningSprints = planningSprints.filter(s => s.Id !== planningSprint.Id);
        updateSelectedProject({
          ProjectSprints: {
            ...contextProject.ProjectSprints,
            ActiveSprint: {
              ...planningSprint,
              SprintStatusId: statusId,
            },
            PlanningSprint: updatedPlanningSprints,
          }
        });
        refreshSelectedProject();
        // Navigate to active view for the newly started sprint
        history.replace({ pathname: "/Project/Sprint", state: { view: "active" } });
        return;
      }

      // When active sprint is Paused or Resumed → just update its StatusId in place
      if (view === "active" && (newStatusCode === "Paused" || newStatusCode === "Active")) {
        updateSelectedProject({
          ProjectSprints: {
            ...contextProject.ProjectSprints,
            ActiveSprint: {
              ...contextProject.ProjectSprints.ActiveSprint,
              SprintStatusId: statusId,
            }
          }
        });
        refreshSelectedProject();
        return;
      }

      // When active sprint is Stopped → move it to CompletedSprints, clear ActiveSprint
      if (newStatusCode === "Stopped" && view === "active") {
        const completedSprints = contextProject.ProjectSprints?.CompletedSprints || [];
        updateSelectedProject({
          ProjectSprints: {
            ...contextProject.ProjectSprints,
            ActiveSprint: null,
            CompletedSprints: [
              ...completedSprints,
              { ...activeSprint, SprintStatusId: statusId }
            ],
          }
        });
        refreshSelectedProject();
        history.replace({ pathname: "/Project/Dashboard" });
        return;
      }

      refreshSelectedProject();
    } catch (e) {
      setIsLoading(false)
      toster.current.error(e?.response?.data?.Message || "Something went wrong");
    } finally {
      setIsLoading(false)
      modalCloser(false);
    }
  };

  const handleDeleteSprint = async (sprint, onClose) => {
    if (!sprint) return;
    setIsDeleting(true);
    setIsLoading(true)
    try {
      const response = await deleteSprintTask({
        ID: sprint?.Id,
        ProjectId: sprint?.ProjectId
      });
      onClose(false);
      setIsLoading(false)
      // // Update context based on which sprint was deleted
      // if (sprint.Id === activeSprint?.Id) {
      //   updateSelectedProject({
      //     ProjectSprints: {
      //       ...contextProject.ProjectSprints,
      //       ActiveSprint: null,
      //     }
      //   });
      //   toster.current.success(response?.Data?.Message || "Active sprint deleted successfully");
      //   refreshSelectedProject();
      //   history.replace({ pathname: "/Project/Dashboard" });
      // } else {
      updateSelectedProject({
        ProjectSprints: {
          ...contextProject.ProjectSprints,
          PlanningSprint: contextProject.ProjectSprints.PlanningSprint.filter(
            s => s.Id !== sprint.Id
          ),
        }
      });
      toster.current.success(response?.Data?.Message || "Planning sprint deleted successfully");
      refreshSelectedProject();
      history.replace({ pathname: "/Project/Dashboard" });
      // }
    } catch (e) {
      setIsLoading(false)
      toster.current.error(e?.response?.data?.Message || "Something went wrong");
    } finally {
      setIsLoading(false)
      setIsDeleting(false);
    }
  };

  // 4. handleStartPlanningSprint mein add karo
  // AFTER:
  const handleStartPlanningSprint = async () => {
    if (activeSprint) return;
    const statusId = getStatusId("Active");
    if (!statusId) {
      toster.current.error("Unable to start sprint. Status not loaded.");
      return;
    }
    setIsLoading(true)
    try {
      const response = await sprintUpdateStatus({
        ID: planningSprint?.Id,
        ProjectId: planningSprint?.ProjectId,
        NewStatusId: statusId,
        Remarks: ""
      });
      toster.current.success(response?.Data?.Message || "Sprint started successfully");
      setCurrentSprintStatusId(statusId);
      setIsLoading(false)
      const updatedPlanningSprints = planningSprints.filter(s => s.Id !== planningSprint.Id);
      updateSelectedProject({
        ProjectSprints: {
          ...contextProject.ProjectSprints,
          ActiveSprint: {
            ...planningSprint,
            SprintStatusId: statusId,
          },
          PlanningSprint: updatedPlanningSprints,
        }
      });
      refreshSelectedProject();
      // Navigate to active view
      history.replace({ pathname: "/Project/Sprint", state: { view: "active" } });
    } catch (e) {
      setIsLoading(false)
      toster.current.error(e?.response?.data?.Message || "Something went wrong");
    }
  };
  const handleDeleteActiveSprint = () => { setDeleteActiveModal(false); history.push("/Project/Dashboard"); };


  async function getProjectTask(page = pageNumber, size = rowsRef.current) {
    const projectId = activeSprint?.ProjectId || planningSprint?.ProjectId;
    if (!projectId) return;
    setIsLoading(true);

    const params = {
      RaisedByEmpId: "",
      AssignedToId: selectedAssingToName?.join(",") || "",
      TaskId: 0,
      StatusId: selectedStatus?.join(",") || "",
      ModuleId: selectedModule?.join(",") || "",
      SubModuleId: selectedSubModule?.join(",") || "",
      PriorityId: selectedPriority?.join(",") || "",
      SeverityId: selectedSeverity?.join(",") || "",
      Search: searchText || "",
      FilterStartDate: "",
      FilterEndDate: "",
      PageNumber: page,      // ← was hardcoded 0
      PageSize: size,        // ← was hardcoded 0
      IsDeleted: 0,
      SprintId: 0,
      TaskNumber: "",
      TaskGUID: "",
      ProjectId: projectId.toString(),
      ParentTaskId: 0,
      TaskTypeId: selectedType?.join(",") || "",
      SegmentId: selectedSegment?.join(",") || "",
      SortBy: sortBy || "",
      SortOrder: sortOrder || "",
    };

    try {
      const data = await getProjectTaskList(params);
      const list = data?.Data?.OrgEmpTasks || [];

      // ← ADD THIS: read total count from API response for paginator
      setTotalRecords(data?.Data?.TotalRecords ?? list.length);

      setIsLoading(false);

      const targetSprintId =
        view === "active"
          ? activeSprint?.Id
          : view === "planning"
            ? planningSprint?.Id
            : null;

      if (targetSprintId == null) {
        setFilteredTasks([]);
        return;
      }

      const filtered = list.filter(
        (task) => Number(task.SprintId) === Number(targetSprintId)
      );

      setFilteredTasks(filtered);
    } catch (e) {
      setIsLoading(false);
      toster.current.error(e?.response?.data?.Message || "Something went wrong");
    }
  }


  // ── TASK DELETE ──────────────────────────────────────────
  async function taskDelete() {
    let body = { Id: deletedTaskId };
    setIsLoading(true);
    try {
      if (deletedTaskId) {
        let response = await deleteTask(body);   // import deleteTask from TaskService if not already
        if (response?.StatusCode === 2000) {
          await getProjectTask();
          setDeleteModal(false);
          setDeletedTaskId(0);
          toster.current.success("Task deleted successfully");
        }
      }
    } catch (error) {
      setIsLoading(false)
      toster.current.error(error?.response?.data?.Message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  }

  // ── MOVE SINGLE TASK TO SPRINT ───────────────────────────
  async function sendMoveSprint() {
    const params = {
      ProjectId: Number(moveSprint?.ProjectId || 0),
      TaskId: Number(moveSprint?.Id || 0),
      SourceSprintId: Number(moveSprint?.SprintId || 0),
      TargetSprintId: Number(moveSprint?.targetSprint?.Id || 0),
    };
    setIsLoading(true);
    try {
      const response = await moveTOSprintTask(params);
      setIsLoading(false)
      setIsSprintModal(false);
      getProjectTask();
      toster.current.success(response?.Data?.Message || "Task moved to sprint successfully")
    } catch (error) {
      setIsLoading(false)
      toster.current.error(
        error?.response?.data?.Message ||
        "Something went wrong"
      );
    } finally {
      setIsLoading(false);
    }
  }

  // ── BULK MOVE TASKS TO SPRINT ────────────────────────────
  async function sendBulkMoveSprint(targetSprint) {
    setIsLoading(true);
    const tasksToMove = filteredTasks.filter(
      t => selectedTasks.includes(t.Id)
    );
    setIsLoading(true)
    try {
      await Promise.all(
        tasksToMove.map(task =>
          moveTOSprintTask({
            ProjectId: Number(task.ProjectId),
            TaskId: Number(task.Id),
            SourceSprintId: Number(task.SprintId || 0),
            TargetSprintId: Number(targetSprint.Id),
          })
        )
      );
      setIsLoading(false)
      toster.current.success(`${tasksToMove.length} task(s) moved to sprint`);
      setSelectedTasks([]);
      setShowBulkBar(false);
      getProjectTask();
    } catch (err) {
      setIsLoading(false)
      toster.current.error(err?.response?.Message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  }

  // ── CLOSE ADD/EDIT MODAL ─────────────────────────────────
  const onClosePopup = (e) => {
    setAddModalOpen(false);
    setEditTaskDetails({});
    setProjectId(0);
    if (e === "success") getProjectTask();
    setParentId(0);
    setTaskCopy(false);
  };




  // async function getProjectTask() {
  //   const projectId = activeSprint?.ProjectId || planningSprint?.ProjectId;
  //   if (!projectId) return;

  //   const targetSprintId =
  //     view === "active"
  //       ? activeSprint?.Id
  //       : view === "planning"
  //         ? planningSprint?.Id
  //         : null;

  //   if (!targetSprintId) {
  //     setFilteredTasks([]);
  //     return;
  //   }

  //   const params = {
  //     RaisedByEmpId: "",
  //     AssignedToId: selectedAssingToName?.join(",") || "",
  //     TaskId: 0,
  //     StatusId: selectedStatus?.join(",") || "",
  //     ModuleId: selectedModule?.join(",") || "",
  //     SubModuleId: selectedSubModule?.join(",") || "",
  //     PriorityId: selectedPriority?.join(",") || "",
  //     SeverityId: selectedSeverity?.join(",") || "",
  //     Search: searchText || "",
  //     FilterStartDate: "",
  //     FilterEndDate: "",
  //     PageNumber: 0,
  //     PageSize: 0,
  //     IsDeleted: 0,
  //     TaskNumber: "",
  //     TaskGUID: "",
  //     ProjectId: projectId.toString(),
  //     SprintId: targetSprintId,          // ← ADD THIS
  //     ParentTaskId: 0,
  //     TaskTypeId: selectedType?.join(",") || "",
  //     SegmentId: selectedSegment?.join(",") || "",
  //     SortBy: sortBy || "",
  //     SortOrder: sortOrder || "",
  //   };

  //   try {
  //     const data = await getProjectTaskList(params);
  //     const list = data?.Data?.OrgEmpTasks || [];

  //     // Client-side guard: filter by SprintId in case API ignores the param
  //     const filtered = list.filter(
  //       (task) => Number(task.SprintId) === Number(targetSprintId)
  //     );

  //     setFilteredTasks(filtered);
  //   } catch (e) {
  //     toster.current.error(e?.response?.data?.Message || "Something went wrong");
  //   }
  // }

  const initials = (name) => name ? name.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase() : "?";

  /* ── sprint info for current view ── */
  const currentSprint = view === "active" ? activeSprint : planningSprint;
  const isActive = view === "active";


 const taskDetail = (id) => {
    window.open(`/Project/Task/Detail/${id}`, "_blank");
  };
  return (
    <div className="pss-area">

      {/* ── welcome bar ── */}
      <div className="task-top-pane">
        <i className="fa fa-thumb-tack i-ico pss-pin-icon" aria-hidden="true"></i>
        <div className="task-top-pane-title">
          <h4>Welcome to OrgGenie</h4>
          <p>Manage your tasks, projects, and workspaces in one place.</p>
        </div>
      </div>

      <div className="tm-main-area">

        {/* ══════════ ACTIVE SPRINT ══════════ */}
        {activeSprint && view === "active" && (
          <>
            {/* ── page header ── */}
            <div className="page-head pss-page-head">
              <div>
                {/* <nav className="pss-breadcrumb">
                  <span>Projects</span>
                  <span className="pss-bc-sep">›</span>
                  <span>{activeSprint.ProjectName || contextProject?.ProjectName || "Project"}</span>
                </nav> */}
                <h2 className="pss-page-title">{activeSprint.SprintName}</h2>
                <p className="pss-page-sub">Active sprint · Ends {formatDate(activeSprint.PlannedEndDate)}</p>
              </div>
              <div className="pss-head-actions">
                <button
                  className="btn btn-brand btn-sm"
                  // onClick={() => setAddModalOpen(true)}
                  onClick={() => {
                    setAddModalOpen(true);
                    setProjectId(activeSprint?.ProjectId);
                    setEditTaskDetails({});
                    setParentId(0);
                    setTaskCopy(false);
                  }}
                >
                  <i className="fa-solid fa-plus"></i> New Task
                </button>
                <Link to="/Project/Dashboard" className="pss-btn-back" title="Back to Dashboard">
                  <svg width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                  </svg>
                </Link>
              </div>
            </div>

            {/* ── sprint detail card ── */}
            <div className="page-bx pb-2">
              <div className="ss-detail-card">

                {/* top accent — green for active */}
                <div className="ss-card-accent ss-card-accent--active"></div>

                <div className="ss-card-body">
                  {/* header row */}
                  <div className="ss-card-head-row">

                    <div className="pss-sprint-name-wrap">
                      <div className="ss-status-dot ss-status-dot--active">
                        <i className="fa-solid fa-bolt"></i>
                      </div>
                      {/* <p className="pss-sprint-name">{activeSprint.SprintName}</p> */}
                      <p className="pss-sprint-dates">
                        {formatDate(activeSprint.PlannedStartDate)}
                        <span className="pss-arrow">→</span>
                        {formatDate(activeSprint.PlannedEndDate)}
                        {activeSprint.SprintGoal && <><span className="pss-dot">·</span>
                          {/* <em>{activeSprint.SprintGoal}</em> */}
                        </>}
                      </p>
                      <span className="ss-running-badge">
                        <span className="ss-pulse"></span>
                        {isSprintPaused ? "Paused" : "Running"}
                      </span>


                    </div>

                    {/* meta boxes */}
                    <div className="pss-meta-row">
                      <div className="pss-meta-box">

                        <span className="pss-meta-val">{activeSprint.TotalTasksInSprint ?? "—"}</span>
                        <span className="pss-meta-label">Total Tasks</span>
                        {/* <span className="ss-meta-sub">in this sprint</span> */}
                      </div>
                      <div className="pss-meta-box">

                        <span className="pss-meta-val pss-meta-val--green"> {activeSprint.TotalTasksInSprint != null && activeSprint.ActiveTasksInSprint != null
                          ? activeSprint.TotalTasksInSprint - activeSprint.ActiveTasksInSprint : "—"}</span>
                        <span className="pss-meta-label">Completed</span>
                        {/* <span className="ss-meta-sub">tasks done</span> */}
                      </div>
                      <div className="pss-meta-box">

                        <span className="pss-meta-val ss-meta-val--orange">


                          {activeSprint.ActiveTasksInSprint ?? "—"}
                        </span>
                        <span className="pss-meta-label">Remaining</span>
                        {/* <span className="ss-meta-sub">tasks left</span> */}
                      </div>
                      {(createProject || userDetails?.EmpId == allProject[0]?.ManagerId) && (
                        <>
                          {isSprintPaused && (
                            <button className="ss-btn btn-pause" onClick={() => setResumeModal(true)} title="Resume sprint">
                              <i className="fa-solid fa-play"></i> Resume Sprint
                            </button>
                          )}
                          {isSprintActive && (
                            <button className="ss-btn ss-btn--warn" onClick={() => setPauseModal(true)} title="Pause">
                              <i className="fa-solid fa-pause"></i>Pause Sprint
                            </button>
                          )}
                          <button className="ss-btn btn-stop" onClick={() => setStopModal(true)} title="Stop Sprint">
                            <i className="fa-solid fa-stop"></i>
                          </button>
                        </>)}
                      {/* <button className="ss-btn  ss-btn--danger" onClick={() => setDeleteActiveModal(true)} title="Delete">
                        <i className="fa-solid fa-trash"></i>
                      </button> */}
                    </div>
                  </div>



                  {/* progress */}
                  <div className="pss-prog-wrap">
                    <div className="ss-prog-label-row">
                      <span className="pss-meta-label">Progress</span>
                      <span className="ss-prog-pct">{calcProgress(activeSprint.ActiveTasksInSprint, activeSprint.TotalTasksInSprint)}%</span>
                    </div>
                    <div className="pss-prog-bar">
                      <div className="pss-prog-fill ss-prog-fill--active" style={{ width: `${calcProgress(activeSprint.ActiveTasksInSprint, activeSprint.TotalTasksInSprint)}%` }}></div>
                    </div>
                  </div>
                </div>

                {/* action footer */}

              </div>
            </div>
          </>
        )}

        {/* ══════════ PLANNING SPRINT ══════════ */}
        {planningSprint && view === "planning" && (
          <>
            <div className="page-head pss-page-head">
              <div>
                {/* <nav className="pss-breadcrumb">
                  <span>Projects</span>
                  <span className="pss-bc-sep">›</span>
                  <span>{planningSprint.ProjectName || contextProject?.ProjectName || "Project"}</span>
                </nav> */}
                <h2 className="pss-page-title">{planningSprint.SprintName}</h2>
                <p className="pss-page-sub">Upcoming sprint · Not started yet</p>
              </div>
              <div className="pss-head-actions">
                <button
                  className="btn btn-brand btn-sm"
                  // onClick={() => setAddModalOpen(true)}
                  onClick={() => {
                    setAddModalOpen(true);
                    setProjectId(planningSprint?.ProjectId);
                    setEditTaskDetails({});
                    setParentId(0);
                    setTaskCopy(false);
                  }}
                >
                  <i className="fa-solid fa-plus"></i> New Task
                </button>
                <Link to="/Project/Dashboard" className="pss-btn-back" title="Back to Dashboard">
                  <svg width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                  </svg>
                </Link>
              </div>
            </div>

            <div className="page-bx pb-2">
              <div className="ss-detail-card">
                <div className="ss-card-accent ss-card-accent--planning"></div>

                <div className="ss-card-body">
                  <div className="ss-card-head-row">


                    <div className="pss-sprint-name-wrap">

                      <div className="ss-status-dot ss-status-dot--planning">
                        <i className="fa-regular fa-clock"></i>
                      </div>
                      {/* <p className="pss-sprint-name">{planningSprint.SprintName}</p> */}
                      <p className="pss-sprint-dates mb-0">
                        {planningSprint.PlannedStartDate
                          ? <>{formatDate(planningSprint.PlannedStartDate)}<span className="pss-arrow">→</span>{formatDate(planningSprint.PlannedEndDate)}</>
                          : "Dates not confirmed yet"}
                        {planningSprint.SprintGoal && <><span className="pss-dot">·</span>
                          {/* <em>{planningSprint.SprintGoal}</em> */}
                        </>}

                      </p>
                      <span className="ss-planning-badge">
                        <i className="fa-solid fa-drafting-compass"></i>
                        Planning
                      </span>

                    </div>

                    <div className="d-flex align-items-start gap-2">

                      <div className="pss-meta-row">
                        <div className="pss-meta-box">

                          <span className="pss-meta-val">{planningSprint.TotalTasksInSprint ?? "—"}</span>
                          <span className="pss-meta-label">Planned Tasks</span>
                          {/* <span className="ss-meta-sub">in backlog for sprint</span> */}
                        </div>
                        <div className="pss-meta-box">

                          <span className="pss-meta-val ss-meta-val--amber">Planning</span>
                          <span className="pss-meta-label">Status</span>
                          {/* <span className="ss-meta-sub">not started yet</span> */}
                        </div>
                        <div className="pss-meta-box">

                          <span className="pss-meta-val">
                            {planningSprint.PlannedStartDate && planningSprint.PlannedEndDate
                              ? `${Math.ceil((new Date(planningSprint.PlannedEndDate) - new Date(planningSprint.PlannedStartDate)) / 86400000)} days`
                              : "—"}
                          </span><span className="pss-meta-label">Duration</span>

                          {/* <span className="ss-meta-sub">planned</span> */}
                        </div>

                      </div>


                      {(createProject || (userDetails?.EmpId == allProject[0]?.ManagerId)) && (
                        <>
                          {!activeSprint && (
                            <button className="ss-btn ss-btn--success" onClick={handleStartPlanningSprint} disabled={filteredTasks.length === 0} title={filteredTasks.length === 0 ? "Please Add Task" : "Start Sprint"}>
                              <i className="fa-solid fa-play"></i> Start Sprint
                            </button>
                          )}
                          <button className="ss-btn ss-btn--ghost" onClick={() => history.push({ pathname: "/Project/Sprints", state: { isEdit: true, editingSprint: planningSprint } })} title="Edit">
                            <i className="fa-solid fa-pen"></i>
                          </button>
                          <button className="ss-btn ss-btn--danger" onClick={() => setDeletePlanningModal(true)} title="Delete">
                            <i className="fa-solid fa-trash"></i>
                          </button> </>)}

                    </div>
                  </div>



                  {/* active sprint warning banner */}
                  {activeSprint && (
                    <div className="ss-info-banner">
                      <i className="fa-solid fa-circle-info"></i>
                      A sprint is currently active. Stop it first to start this sprint.
                    </div>
                  )}
                </div>

                {/* <div className="ss-card-foot">
                  
                  
                </div> */}
              </div>
            </div>
          </>
        )}

        {/* ══════════ FILTER COLLAPSIBLE SECTION ══════════ */}
        {(activeSprint || planningSprint) && (
          <div className="collapsible-section" id="filterSection" onClick={() => toggleSection("filter")}>
            <div className="section-toggle">
              <div className="section-toggle-icon icon-filter" onClick={() => toggleSection("filter")}>
                <svg viewBox="0 0 28 28" width="28" height="28" xmlns="http://www.w3.org/2000/svg" fill="none">
                  <rect width="28" height="28" rx="8" fill="#f0fdf4" />
                  <path d="M7 9.5h14M9.5 14h9M12 18.5h4" stroke="#15803d" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
              </div>
              <span className="section-label" onClick={() => toggleSection("filter")}>Filters</span>

              <div className="sort-bydiv" onClick={(e) => e.stopPropagation()}>
                <label style={{ fontSize: "11px", color: "var(--muted)", whiteSpace: "nowrap", marginBottom: "0" }}>Sort By:</label>
                <select
                  className="fs"
                  style={{ width: "auto" }}
                  value={sortBy}
                  onChange={(e) => {
                    setSortBy(e.target.value);
                    setSortOrder("ASC");
                  }}
                >
                  {SORT_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>

                <button
                  type="button"
                  className="btn btn-ghost btn-icon btn-sm"
                  title={sortOrder === "ASC" ? "Ascending — click for Descending" : "Descending — click for Ascending"}
                  onClick={toggleSortOrder}
                  disabled={!sortBy}
                  style={{
                    opacity: sortBy ? 1 : 0.35,
                    cursor: sortBy ? "pointer" : "not-allowed",
                    fontSize: "13px",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid var(--border)",
                    borderRadius: "var(--radius)",
                    background: sortBy ? "var(--card)" : "transparent",
                    transition: "all 0.15s",
                  }}
                >
                  {sortOrder === "ASC" ? <i className="fa-solid fa-arrow-up-a-z"></i> : <i className="fa-solid fa-arrow-down-z-a"></i>}
                </button>
              </div>
            </div>

            <div className={`section-body ${filterOpen ? "open" : ""}`} id="filterBody">
              <div className="section-body-inner" onClick={(e) => e.stopPropagation()}>
                <div className="toolbar my-toolbar">
                  <div className="toolbar-sepdiv">
                    <div className="sw" style={{ flex: "2 1 220px", minWidth: 180 }}>
                      <i className="fa-solid fa-magnifying-glass"></i>
                      <input
                        className="si"
                        placeholder="Search tasks, ID…"
                        value={inputText}
                        onChange={(e) => {
                          const value = e.target.value;
                          setInputText(value);
                          if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
                          debounceTimerRef.current = setTimeout(() => {
                            setSearchText(value);
                          }, 1000);
                        }}
                        style={{ width: "100%" }}
                      />
                    </div>

                    <div className="tsep"></div>

                    <MultiSelect
                      value={selectedStatus}
                      onChange={(e) => setSelectedStatus(e.value)}
                      options={taskStatusType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Status"
                      filter
                    />

                    <MultiSelect
                      value={selectedAssingToName}
                      onChange={(e) => setSelectedAssingToName(e.value)}
                      options={employeDetails}
                      optionLabel="FullName"
                      optionValue="Id"
                      placeholder="Assigned To"
                      filter
                      style={{ flex: "1 1 140px", minWidth: 130 }}
                    />

                    <MultiSelect
                      value={selectedType}
                      onChange={(e) => setSelectedType(e.value)}
                      options={taskType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Types"
                      filter
                    />

                    <MultiSelect
                      value={selectedPriority}
                      onChange={(e) => setSelectedPriority(e.value)}
                      options={taskPriorityType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Priority"
                      filter
                    />

                    <MultiSelect
                      value={selectedSeverity}
                      onChange={(e) => setSelectedSeverity(e.value)}
                      options={taskSeverityType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Severity"
                      filter
                    />

                    <Dropdown
                      value={selectedProject ?? null}
                      options={allProject}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Projects"
                      filter
                      disabled={selectedProject}
                      showClear
                      style={{ flex: "1 1 193px", maxWidth: 193 }}
                      onChange={(e) => {
                        const val = e.value ?? null;
                        setSelectedProject(val);
                        selectedProjectRef.current = val;
                        setSelectedModule([]);
                        setSelectedSubModule([]);
                        setSelectedSegment([]);
                        setTaskModuleType([]);
                        setTaskSubModuleType([]);
                        setTaskSegmentType([]);
                        if (val) {
                          getMasterTaskModulesCategory(val);
                          getMasterTaskSegmentCategory(val);
                        }
                      }}
                    />

                    <MultiSelect
                      value={selectedModule}
                      onChange={(e) => {
                        const val = e.value;
                        setSelectedModule(val);
                        setSelectedSubModule([]);
                        setTaskSubModuleType([]);
                        if (val?.length === 1)
                          getMasterTaskSubModuleCategory(selectedProject, val[0]);
                      }}
                      options={taskModuleType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="Select Module"
                      filter
                      disabled={!selectedProject}
                    />

                    <MultiSelect
                      value={selectedSubModule}
                      onChange={(e) => setSelectedSubModule(e.value)}
                      options={taskSubModuleType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="Select Sub-Module"
                      filter
                      disabled={!selectedModule.length}
                    />

                    <MultiSelect
                      value={selectedSegment}
                      onChange={(e) => setSelectedSegment(e.value)}
                      options={taskSegmentType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="Select Segment"
                      filter
                      disabled={!selectedProject}
                    />

                    <div className="tsep"></div>
                    <button
                      className="btn btn-ghost btn-sm"
                      onClick={clearFilters}
                      disabled={!hasActiveFilters}
                      title="Clear all filters"
                      style={{
                        opacity: hasActiveFilters ? 1 : 0.4,
                        cursor: hasActiveFilters ? "pointer" : "not-allowed",
                      }}
                    >
                      <i className="fa-solid fa-xmark"></i> Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}


        {/* ══════════ TASK TABLE ══════════ */}
        {(activeSprint || planningSprint) && (
          <div className="pss-task-view">
            <div className="height-body-equal">
              <table className="dtbl">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedTasks(filteredTasks.map(t => t.Id));
                            setShowBulkBar(true);
                          } else {
                            setSelectedTasks([]);
                            setShowBulkBar(false);
                          }
                        }}
                        checked={
                          filteredTasks.length > 0 &&
                          selectedTasks.length === filteredTasks.length
                        }
                      />
                    </th>
                    <th>Title</th>
                    <th>Task ID</th>
                    <th>Type · Priority · Severity</th>
                    <th>Status</th>
                    <th>Assigned To</th>
                    <th>Due · Est</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTasks.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="pss-no-data">
                        <i className="fa-solid fa-inbox pss-no-data-icon"></i>
                        No tasks found for this sprint
                      </td>
                    </tr>
                  ) : (
                    filteredTasks.map((task, idx) => {
                      const titleTrimmed = task.TaskTitle?.length > 45 ? task.TaskTitle.slice(0, 45) + "…" : task.TaskTitle;
                      return (
                        <tr key={task?.Id} className="pss-tr">
                          <td onClick={(e) => e.stopPropagation()}>
                            <input
                              type="checkbox"
                              checked={selectedTasks.includes(task.Id)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedTasks(prev => [...prev, task.Id]);
                                  setShowBulkBar(true);
                                } else {
                                  const updated = selectedTasks.filter(id => id !== task.Id);
                                  setSelectedTasks(updated);
                                  if (updated.length === 0) setShowBulkBar(false);
                                }
                              }}
                            />
                          </td>
                          <td className="pss-td pss-td--title">
                            <p className="pss-task-title" onClick={() => taskDetail(selectedTask?.GUID)}>{getValue(titleTrimmed)}</p>
                            <p className="pss-task-meta">
                              <span title={task.IsPublic ? "Public" : "Private"}>
                                <i className={`fa-solid ${task.IsPublic ? "fa-lock-open pss-icon--red" : "fa-lock pss-icon--muted"}`}></i>
                              </span>
                              <span>{getValue(task.ProjectName)}</span>
                              {task.ModuleName && <><span className="pss-meta-sep">·</span><span>{task.ModuleName}</span></>}
                              {task.SubModuleName && <><span className="pss-meta-sep">-</span><span>{task.SubModuleName}</span></>}
                              {task.CreatedByFullName && (
                                <>
                                  <span className="pss-meta-sep">·</span>
                                  <img src={task.CreatedByProfileImage || "/images/placeholder_profile.png"} onError={e => e.target.src = "/images/placeholder_profile.png"} className="pss-mini-avatar" />
                                  <span>{task.CreatedByFullName}</span>
                                </>
                              )}
                            </p>
                          </td>
                          <td className="pss-td">
                            <span className="pss-task-num">{getValue(task.TaskNumber)}</span>
                          </td>
                          <td className="pss-td pss-td--nowrap">
                            <div className="pss-type-name">{getValue(task.TaskTypeName)}</div>
                            <div className="pss-type-sub">{getValue(task.PriorityName)} · {getValue(task.SeverityName)}</div>
                          </td>
                          <td className="pss-td">
                            <span className={pillClass(task.StatusName)}>{getValue(task.StatusName)}</span>
                          </td>
                          <td className="pss-td">
                            <div className="pss-assignee">
                              {task.AssignToProfileImage && (
                                <img
                                  src={
                                    task.AssignToProfileImage ||
                                    "images/placeholder_profile.png"
                                  }
                                  onError={(e) =>
                                  (e.target.src =
                                    "/images/placeholder_profile.png")
                                  }
                                  className="pss-avatar"
                                />
                              )}
                              <span className="pss-assignee-name">{getValue(task.AssignToName)}</span>
                            </div>
                          </td>
                          <td className="pss-td pss-td--nowrap">
                            <div className="pss-due-date">
                              {task.DueDate ? new Date(task.DueDate).toLocaleDateString("en-GB", { day: "numeric", month: "short" }) : "—"}
                            </div>
                            <div className="pss-est-hrs">{task.EstimatedHours ? `${task.EstimatedHours}h est.` : "—"}</div>
                          </td>
                          <td
                            className="task-actions-cell"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="flex gap4 task-actions">
                              <button
                                title="Clone"
                                type="button"
                                onClick={() => {
                                  setAddModalOpen(true);
                                  setEditTaskDetails(task);
                                  setParentId(0);
                                  setProjectId(task?.ProjectId);
                                  setTaskCopy(true);
                                }}
                                className="btn btn-ghost btn-icon"
                              >
                                <i className="fa-solid fa-copy"></i>
                              </button>
                              <button
                                title="Edit"
                                type="button"
                                onClick={() => {
                                  setAddModalOpen(true);
                                  setEditTaskDetails(task);
                                  setParentId(0);
                                  setProjectId(task?.ProjectId);
                                  setTaskCopy(false);
                                }}
                                className="btn btn-ghost btn-icon"
                              >
                                <i className="fa-solid fa-pen"></i>
                              </button>
                              <button
                                title="Delete"
                                className="btn btn-ghost btn-icon"
                                style={{ color: "var(--red)" }}
                                onClick={() => {
                                  setDeleteModal(true);
                                  setDeletedTaskId(task?.Id);
                                }}
                              >
                                <i className="fa-solid fa-trash"></i>
                              </button>
                              {console.log(contextProject?.ManagerId, "selectedProject?.ManagerId")}
                              {(createProject || userDetails?.EmpId == contextProject?.ManagerId) && (
                                <div className="bt-move-wrap" style={{ position: "relative" }}>
                                  <button
                                    className="bt-move-btn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (sprintDropdownTaskId === task.Id) {
                                        setSprintDropdownTaskId(null);
                                      } else {
                                        // ✅ FIX: contextProject already has ProjectSprints populated
                                        setSelectedProjectData(contextProject);
                                        setSprintDropdownTaskId(task.Id);
                                      }
                                    }}
                                    title="Move to Sprint"
                                  >
                                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-send" viewBox="0 0 16 16">
                                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                                  </svg> */}
                                    <i className="fa-solid fa-arrow-right-to-bracket" style={{ fontSize: "11px" }}></i>
                                    <i className="fa-solid fa-chevron-down" style={{ fontSize: "8px" }}></i>
                                  </button>

                                  {sprintDropdownTaskId === task.Id && (
                                    <div className="sprint-pick-dd open"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <div style={{ padding: "6px 12px", fontSize: "11px", color: "var(--muted)", fontWeight: 600, borderBottom: "1px solid var(--border)" }}>
                                        Move to Sprint
                                      </div>
                                      {/* Move to Backlog */}
                                      <div
                                        style={{ padding: "8px 14px", cursor: "pointer", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px" }}
                                        className="sprint-drop-item"
                                        onMouseEnter={e => e.currentTarget.style.background = "var(--brand-soft, #fef2f0)"}
                                        onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                        onClick={() => {
                                          setIsSprintModal(true);
                                          setMoveSprint({ ...task, targetSprint: { Id: 0, SprintName: "Backlog", SprintNumber: "" } });
                                          setSprintDropdownTaskId(null);
                                        }}
                                      >
                                        <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#f59e0b", flexShrink: 0, display: "inline-block" }}></span>
                                        <span>
                                          <span style={{ fontSize: "10px", color: "var(--muted)", display: "block" }}>Backlog</span>
                                          Move to Backlog
                                        </span>
                                      </div>

                                      {/* Active Sprint */}
                                      {selectedProjectData?.ProjectSprints?.ActiveSprint &&
                                        Number(selectedProjectData.ProjectSprints.ActiveSprint.Id) !== Number(task.SprintId) && (
                                          <div
                                            style={{ padding: "8px 14px", cursor: "pointer", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px" }}
                                            className="sprint-drop-item"
                                            onMouseEnter={e => e.currentTarget.style.background = "var(--brand-soft, #fef2f0)"}
                                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                            onClick={() => {
                                              setIsSprintModal(true);
                                              setMoveSprint({ ...task, targetSprint: selectedProjectData.ProjectSprints.ActiveSprint });
                                              setSprintDropdownTaskId(null);
                                            }}
                                          >
                                            <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#22c55e", flexShrink: 0, display: "inline-block" }}></span>
                                            <span>
                                              <span style={{ fontSize: "10px", color: "var(--muted)", display: "block" }}>Active Sprint</span>
                                              {selectedProjectData.ProjectSprints.ActiveSprint.SprintName}
                                            </span>
                                          </div>
                                        )}

                                      {/* Planning Sprints */}
                                      {selectedProjectData?.ProjectSprints?.PlanningSprint?.length > 0 &&
                                        selectedProjectData.ProjectSprints.PlanningSprint
                                          .filter(sprint => Number(sprint.Id) !== Number(task.SprintId))
                                          .map((sprint) => (
                                            <div
                                              key={sprint.Id}
                                              style={{ padding: "8px 14px", cursor: "pointer", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px" }}
                                              onMouseEnter={e => e.currentTarget.style.background = "var(--brand-soft, #fef2f0)"}
                                              onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                              onClick={() => {
                                                setIsSprintModal(true);
                                                setMoveSprint({ ...task, targetSprint: sprint });
                                                setSprintDropdownTaskId(null);
                                              }}
                                            >
                                              <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#3b82f6", flexShrink: 0, display: "inline-block" }}></span>
                                              <span>
                                                <span style={{ fontSize: "10px", color: "var(--muted)", display: "block" }}>Planning Sprint</span>
                                                {sprint.SprintName}
                                              </span>
                                            </div>
                                          ))
                                      }
                                      {/* Agar koi sprint nahi */}
                                      {!selectedProjectData?.ProjectSprints?.ActiveSprint &&
                                        !selectedProjectData?.ProjectSprints?.PlanningSprint?.length && (
                                          <div style={{ padding: "10px 14px", fontSize: "13px", color: "var(--muted)" }}>
                                            No sprints available
                                          </div>
                                        )}

                                      {(() => {
                                        const hasActive = selectedProjectData?.ProjectSprints?.ActiveSprint &&
                                          Number(selectedProjectData.ProjectSprints.ActiveSprint.Id) !== Number(task.SprintId);
                                        const hasPlanning = selectedProjectData?.ProjectSprints?.PlanningSprint?.some(
                                          s => Number(s.Id) !== Number(task.SprintId)
                                        );
                                        const hasAnySprint = selectedProjectData?.ProjectSprints?.ActiveSprint ||
                                          selectedProjectData?.ProjectSprints?.PlanningSprint?.length;
                                        if (hasAnySprint && !hasActive && !hasPlanning) {
                                          return (
                                            <div style={{ padding: "10px 14px", fontSize: "13px", color: "var(--muted)" }}>
                                              Task is already in the only available sprint
                                            </div>
                                          );
                                        }
                                        return null;
                                      })()}
                                    </div>
                                  )}
                                </div>)}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
              <Paginator
                first={first}
                rows={rows}
                totalRecords={totalRecords}
                rowsPerPageOptions={[50, 100, 200, 500]}
                onPageChange={onPageChange}
              />
            </div>
          </div>
        )}
      </div>

      

      {/* ══════════ FALLBACK STATES ══════════ */}
      {view === "active" && !activeSprint && (
        <div className="tm-main-area">
          <div className="pss-empty" style={{ padding: "60px 20px" }}>
            <i className="fa-solid fa-bolt pss-empty-icon"></i>
            <p>No active sprint found for this project.</p>
            <Link to="/Project/Dashboard" className="pss-btn-viewall" style={{ marginTop: "14px", textDecoration: "none" }}>Go to Dashboard</Link>
          </div>
        </div>
      )}
      {view === "planning" && !planningSprint && (
        <div className="tm-main-area">
          <div className="pss-empty" style={{ padding: "30px 20px" }}>
            <i className="fa-regular fa-clock pss-empty-icon"></i>
            <p>No planning sprint found for this project.</p>
            <Link to="/Project/Dashboard" className="pss-btn-viewall" style={{ textDecoration: "none" }}>Go to Dashboard</Link>
          </div>
        </div>
      )}
      {!view && !activeSprint && !planningSprint && (
        <div className="tm-main-area">
          <div className="pss-empty" style={{ padding: "60px 20px" }}>
            <i className="fa-solid fa-layer-group pss-empty-icon"></i>
            <p>No sprint data found. Please select a project from the sidebar.</p>
            <Link to="/Project/Dashboard" className="pss-btn-viewall" style={{ marginTop: "14px", textDecoration: "none" }}>Go to Dashboard</Link>
          </div>
        </div>
      )}

      {/* ══════════ MODALS ══════════ */}
      {[
        { show: isResumeModal, icon: "fa-play", iconColor: "#22c55e", title: `Resume ${activeSprint?.SprintName} ?`, body: "This will resume progress tracking for the sprint.", cancelLabel: "Cancel", confirmLabel: "Resume Sprint", onConfirm: () => handleSprintStatusUpdate("Active", setResumeModal, "Sprint resumed successfully"), onCancel: () => setResumeModal(false) },
        { show: isStopModal, icon: "fa-stop", iconColor: "#d97706", title: `Stop ${activeSprint?.SprintName} ?`, body: "Stopping marks it completed. Incomplete tasks return to Backlog. This cannot be undone.", cancelLabel: "Keep Sprint", confirmLabel: "Stop Sprint", onConfirm: () => handleSprintStatusUpdate("Stopped", setStopModal, "Sprint stopped successfully"), onCancel: () => setStopModal(false) },
        { show: isPauseModal, icon: "fa-pause", iconColor: "#d97706", title: `Pause ${activeSprint?.SprintName} ?`, body: "Pausing temporarily halts progress tracking. You can resume it anytime.", cancelLabel: "Cancel", confirmLabel: "Pause Sprint", onConfirm: () => handleSprintStatusUpdate("Paused", setPauseModal, "Sprint paused successfully"), onCancel: () => setPauseModal(false) },
        {
          show: isDeleteActiveModal,
          icon: "fa-triangle-exclamation",
          iconColor: "#ef4444",
          title: `Delete  ${activeSprint?.SprintName} ?`,
          body: "This sprint is active. Deleting it moves all tasks back to the Backlog. This cannot be undone.",
          cancelLabel: "Keep Sprint",
          confirmLabel: isDeleting ? "Deleting…" : "Delete Sprint",
          onConfirm: () => handleDeleteSprint(activeSprint, setDeleteActiveModal),  // ✅ passes activeSprint
          onCancel: () => setDeleteActiveModal(false)
        },
        {
          show: isDeletePlanningModal,
          icon: "fa-triangle-exclamation",
          iconColor: "#ef4444",
          title: `Delete  ${planningSprint?.SprintName} ?`,
          body: "This planning sprint will be permanently removed. Tasks return to the Backlog. This cannot be undone.",
          cancelLabel: "Keep Sprint",
          confirmLabel: isDeleting ? "Deleting…" : "Delete Sprint",
          onConfirm: () => handleDeleteSprint(planningSprint, setDeletePlanningModal),  // ✅ passes planningSprint
          onCancel: () => setDeletePlanningModal(false)
        },].map(({ show, icon, iconColor, title, body, cancelLabel, confirmLabel, onConfirm, onCancel }) =>
          show && (
            <div key={title} className="ss-modal-overlay">
              <div className="ss-modal">
                <div className="ss-modal-body">
                  <div className="ss-modal-icon-wrap">
                    <i className={`fa-solid ${icon}`} style={{ color: iconColor }}></i>
                  </div>
                  <div className="ss-modal-content">
                    <h4 className="ss-modal-title">{title}</h4>
                    <p className="ss-modal-text">{body}</p>
                  </div>
                </div>
                <div className="ss-modal-foot">
                  <button className="ss-btn ss-btn--ghost" onClick={onCancel}>{cancelLabel}</button>
                  <button className="ss-btn ss-btn--danger" onClick={onConfirm} disabled={isDeleting}>{confirmLabel}</button>
                </div>
              </div>
            </div>
          )
        )}


      {showBulkBar && selectedTasks.length > 0 && (
        <div
          id="bulkBar"
          style={{
            position: "fixed",
            bottom: "24px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 18px",
            background: "var(--card)",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
            minWidth: "320px",
          }}
        >
          <span style={{ fontSize: "13px", fontWeight: 700, color: "var(--brand)", whiteSpace: "nowrap" }}>
            {selectedTasks.length} task{selectedTasks.length > 1 ? "s" : ""} selected
          </span>
          <div className="tsep" />
          {(() => {
            const sprintMap = new Map();
            if (contextProject?.ProjectSprints?.ActiveSprint) {
              const s = contextProject.ProjectSprints.ActiveSprint;
              sprintMap.set(s.Id, { ...s, _type: "Active" });
            }
            (contextProject?.ProjectSprints?.PlanningSprint || []).forEach(s => {
              if (!sprintMap.has(s.Id)) sprintMap.set(s.Id, { ...s, _type: "Planning" });
            });
            const selectedTaskObjects = filteredTasks.filter(t => selectedTasks.includes(t.Id));
            const sprints = [...sprintMap.values()].filter(sprint =>
              !selectedTaskObjects.every(t => Number(t.SprintId) === Number(sprint.Id))
            );
            return (
              <div className="bt-move-wrap" style={{ position: "relative" }}>
                <button
                  className="btn btn-outline btn-sm"
                  disabled={!(createProject || userDetails?.EmpId == contextProject?.ManagerId)}
                  style={{ display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setSprintDropdownTaskId(sprintDropdownTaskId === "bulk" ? null : "bulk");
                  }}
                >
                  <i className="fa-solid fa-arrow-right-to-bracket" style={{ fontSize: "11px" }} />
                  Move to Sprint
                  <i className="fa-solid fa-chevron-down" style={{ fontSize: "8px" }} />
                </button>

                {sprintDropdownTaskId === "bulk" && (createProject || userDetails?.EmpId == allProject[0]?.ManagerId) && (
                  <div
                    className="sprint-pick-dd open"
                    style={{ bottom: "calc(100% + 6px)", top: "auto", minWidth: "200px" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div style={{ padding: "6px 12px", fontSize: "11px", color: "var(--muted)", fontWeight: 600, borderBottom: "1px solid var(--border)" }}>
                      Move {selectedTasks.length} task(s) to Sprint
                    </div>

                    {/* ✅ Always show Move to Backlog — no longer gated by sprints.length */}
                    <div
                      className="sprint-drop-item"
                      style={{ padding: "8px 14px", cursor: "pointer", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px" }}
                      onMouseEnter={e => e.currentTarget.style.background = "var(--brand-soft, #fef2f0)"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                      onClick={() => {
                        setSprintDropdownTaskId(null);
                        sendBulkMoveSprint({ Id: 0, SprintName: "Backlog", SprintNumber: "" });
                      }}
                    >
                      <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#f59e0b", flexShrink: 0, display: "inline-block" }} />
                      <span>
                        <span style={{ fontSize: "10px", color: "var(--muted)", display: "block" }}>Backlog</span>
                        Move to Backlog
                      </span>
                    </div>

                    {/* Sprint options — only shown when available */}
                    {sprints.length > 0 ? (
                      sprints.map(sprint => (
                        <div
                          key={sprint.Id}
                          className="sprint-drop-item"
                          style={{ padding: "8px 14px", cursor: "pointer", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px" }}
                          onMouseEnter={e => e.currentTarget.style.background = "var(--brand-soft, #fef2f0)"}
                          onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                          onClick={() => {
                            setSprintDropdownTaskId(null);
                            sendBulkMoveSprint(sprint);
                          }}
                        >
                          <span style={{
                            width: "8px", height: "8px", borderRadius: "50%",
                            background: sprint._type === "Active" ? "#22c55e" : "#3b82f6",
                            flexShrink: 0, display: "inline-block"
                          }} />
                          <span>
                            <span style={{ fontSize: "10px", color: "var(--muted)", display: "block" }}>
                              {sprint._type} Sprint
                            </span>
                            {sprint.SprintName}
                          </span>
                        </div>
                      ))
                    ) : (
                      <div style={{ padding: "6px 14px 10px", fontSize: "12px", color: "var(--muted)" }}>
                        No other sprints available
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })()}

          <div className="tsep" />

          <button
            className="btn btn-ghost btn-sm"
            onClick={() => {
              setShowBulkBar(false);
              setSelectedTasks([]);
              setSprintDropdownTaskId(null);
            }}
          >
            <i className="fa-solid fa-xmark" /> Cancel
          </button>
        </div>
      )}

      {/* ── DELETE TASK MODAL ── */}
      {isDeletedModal && (
        <div className="modal show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img src="/images/org-img/leave/popup-backimg.png" className="backimg" />
                <div className="img"><img src="/images/org-img/leave/trash.png" /></div>
              </div>
              <div className="modal-body text-center">
                <p>Are you sure you want to delete this task?</p>
              </div>
              <div className="modal-footer m-auto">
                <button type="button" className="cancelbtn-click"
                  onClick={() => { setDeleteModal(false); setDeletedTaskId(0); }}>
                  Cancel
                </button>
                <button type="button" className="deletebtn-click"
                  onClick={() => taskDelete()}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── MOVE TO SPRINT CONFIRM MODAL ── */}
      {isSprintModal && (
        <div className="modal show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img src="/images/org-img/leave/popup-backimg.png" className="backimg" />
                <div className="img">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-send" viewBox="0 0 16 16">
                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                  </svg>
                </div>
              </div>
              <div className="modal-body text-center">
                <p>Are you sure you want to move to this sprint?</p>
              </div>
              <div className="modal-footer m-auto">
                <button type="button" className="cancelbtn-click"
                  onClick={() => setIsSprintModal(false)}>
                  Cancel
                </button>
                <button type="button" className="deletebtn-click"
                  onClick={() => sendMoveSprint()}>
                  Move To Sprint
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {
        (isLoading) && (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        )
      }

      {isPauseSprintModal && (
        <div className="modal show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img src="/images/org-img/leave/popup-backimg.png" className="backimg" />
                <div className="img">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-send" viewBox="0 0 16 16">
                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                  </svg>
                </div>
              </div>
              <div className="modal-body text-center">
                <p>Are you sure you want stop to this sprint?</p>
              </div>
              <div className="modal-footer m-auto">
                <button type="button" className="cancelbtn-click"
                  onClick={() => setIsPauseSprintModal(false)}>
                  Cancel
                </button>
                <button type="button" className="deletebtn-click"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── ADD / EDIT TASK MODAL ── */}
      {isModalOpen && (
        <AddTask
          isOpen={isModalOpen}
          onClose={(e) => onClosePopup(e)}
          editTaskDetails={editTaskDetails}
          subTaskProjectId={subTaskProjectId}
          parentId={parentId}
          taskCopy={taskCopy}
          detailPage={false}
        />
      )}
    </div>

  );
}

export default SprintSection;